import { render, staticRenderFns } from "./SplaServiceWizard.vue?vue&type=template&id=08f49636&"
import script from "./SplaServiceWizard.vue?vue&type=script&lang=js&"
export * from "./SplaServiceWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports